module.exports = __webpack_public_path__ + "img/toc-tac-toe.60740125.png";